import { getData, getElement, tabs } from "../../../../helpers";
import { Dt } from "../../../../plugins/datatable";
import { CompanyModal as Company } from "./modals/store";
import { BankModal as Bank } from "../banks/modals/store";
import { DirectoryModal } from "../directories/modals/store";
import { get } from "jquery";

class ShowCompanyModule extends HTMLElement {
    connectedCallback() {
        this.load();
        this.events();
    }

    load() {
        const DtAddresses = getElement("[data-table=dtAddresses]", this);
        const DtBanks = getElement("[data-table=dtBanks]", this);

        this.addEventListener("click", (e) => {
            const BtnEditCompany = e.target.closest(".target.edit");
            const BtnEditBank = e.target.closest("[name=btnEditBank]");
            const Tab = e.target.closest("[data-bs-toggle=pill]");
            const NewDirectory = e.target.closest("[data-target=newDirectory]");

            // Editar Empresa
            if (BtnEditCompany) {
                Company.edit(
                    getData(BtnEditCompany, "data-bs-target"),
                    getData(BtnEditCompany, "title"),
                    getData(BtnEditCompany, "data-url"),
                    getData(BtnEditCompany, "data-data")
                );
            }

            // Editar Banco
            if (BtnEditBank) {
                Bank.edit(
                    getData(BtnEditBank, "data-bs-target"),
                    getData(BtnEditBank, "title"),
                    getData(BtnEditBank, "data-url"),
                    getData(BtnEditBank, "data-data")
                );
            }

            // Recordar Tab
            if (Tab) {
                tabs(Tab);
            }

            // Nuevo Directorio
            if (NewDirectory) {
                DirectoryModal.create(
                    getData(NewDirectory, "data-bs-target"),
                    getData(NewDirectory, "title"),
                    getData(NewDirectory, "data-url")
                );
            }
        });

        // Start DataTable
        let configDt = {
            pageLength: 3,
            lengthChange: false,
            ordering: false,
            columnDefs: [
                {
                    targets: [0, 2, 3],
                    width: "5%",
                    className: "text-center",
                },
            ],
        };

        const DtA = new Dt(configDt);
        DtA.dataTable(DtAddresses);
        // End DataTable

        // Start DataTable
        configDt = {
            pageLength: 4,
            lengthChange: false,
            ordering: false,
            columnDefs: [
                {
                    targets: [0, 6],
                    width: "5%",
                    className: "text-center",
                },
            ],
        };

        const DtB = new Dt(configDt);
        DtB.dataTable(DtBanks);
        // End DataTable
    }

    events() {
        const Form = getElement("[name=lockForm]", this);

        Form.elements.lock.addEventListener("click", () => {
            if (Form.reportValidity()) {
                Form.submit();
            }
        });

        Form.elements.lockDate.addEventListener("input", () => {
            if (Form.elements.lockDate.value.length == 0) {
                Form.elements.lock.innerHTML = getData(
                    Form.elements.lockDate,
                    "data-icon-unlock"
                );
            } else {
                Form.elements.lock.innerHTML = getData(
                    Form.elements.lockDate,
                    "data-icon-lock"
                );
            }
        });
    }
}

window.customElements.define("showcompany-module", ShowCompanyModule, {
    extends: "section",
});
